import looper3 from "../../../assets/images/accunalysis.svg";
import looper4 from "../../../assets/images/accunalysis.svg";
import iphone from "../../../assets/images/accunalysis.svg";

const LandingStyle = (theme) => ({
    rowContainer: {
        width: "100%",
        margin: "0px",
    },

    productCard: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        paddingBottom: "32px",
        width: "282px",
        height: "550px",
        boxShadow: "0px 2px 4px rgba(11, 59, 60, 0.05)",
    },
    labPkgCard: {
        // paddingLeft: "16px",
        // paddingRight: "16px",
        // paddingTop: "24px",
        // paddingBottom: "32px",
        width: "450px",
        height: "auto",
        border: '2px solid #E3EAF6',
        boxShadow: "0px 2px 4px rgba(11, 59, 60, 0.05)",
    },
    homeSampleStyle: {
        paddingTop: "24px",
        paddingBottom: "32px",
        borderRadius: '3px',
        width: "436px",
        height: "78px",
        gridGap: '3px',
        border: '2px solid #E3EAF6',
        margin: "16px",

    },
    homeSampleStyle22: {
        paddingTop: "24px",
        paddingBottom: "32px",
        borderRadius: '3px',
        width: "436px",
        height: "120px",
        gridGap: '3px',
        border: '2px solid #E3EAF6',
        margin: "16px",

    },

    titleContainer: {
        background: "#F2F8F9",
        width: "250px",
        height: "auto",
        gridGap: "14px",
        marginBottom: "20px",
    },
    labtitleContainer: {
        background: "#FFF0ED",
        width: "436px",
        height: "100px",
        gridGap: "10px",
        borderRadius: '3px',
        marginBottom: "20px",
        color:"white"
    },
    pkgTitleContainer: {
        background: "#F7F8FB",
        width: "478px",
        height: "107px",
        gridGap: "10px",
        marginBottom: "10px",
    },
    productTitle: {
        ...theme.typography.title,
        color: "#00839B",
    },
    productTitle22: {
        ...theme.typography.title,
        color: "#00839B",
        textAlign: "left",
        fontWeight: "700",
        fontSize: "22px",
    },
    viewTestButton: {
        ...theme.typography.primaryButton,
        width: "250px",
        height: "48px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        backgroundColor: '#FF5C3C',
        color: 'white'

    },
    addToCartButton: {
        ...theme.typography.primaryButton,
        width: "415px",
        height: "51px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        backgroundColor: '#FF5C3C',
        color: 'white',
        margin: "16px",
    },
    appLinkContainer: {
        maxWidth: "1248px",
        height: "auto",
        background: "#005F71",
        borderRadius: "10px",
        backgroundImage: `url(${iphone}),url(${looper3})`,
        backgroundPosition: "right bottom",
        backgroundRepeat: "no-repeat",

        [theme.breakpoints.down("md")]: {
            width: "80%",
            backgroundImage: `url(${looper3})`,
        },
    },
    linkBox: {
        paddingLeft: "10.1rem",
        paddingTop: "4.7rem",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "0px",
        },
    },
    StoreMain: {
        display: "flex",

        background: "#FFFFFF",
        /* Gray/100 */

        border: "2px solid #F2F4F7",
        borderRadius: "5.31px",
    },
    blogContainer: {
        paddingLeft: "9.7rem",
        paddingTop: "7.6rem",
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "0px",
        },
    },
    viewBlogsButton: {
        ...theme.typography.secondaryButton,
        width: "157px",
        padding: "12px 18px",
        background: "#FF5C3C",
        border: "1px solid #FF5C3C",
        boxSizing: "border-box",
        marginRight: "6.3rem",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        borderRadius: "8px",
        fontFamily: "inherit",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
    },
    blogCard: {
        width: "384px",
        height: "440px",
        boxShadow: "none",
        borderRadius: "0px",
        position: "relative",
        [theme.breakpoints.down("xs")]: {
            width: "300px",
            height: "500px",
        },
    },
    blogCard2: {
        width: "384px",
        height: "520px",
        boxShadow: "none",
        borderRadius: "0px",
        position: "relative",
        [theme.breakpoints.down("xs")]: {
            width: "300px",
            height: "500px",
        },
    },
    cardSetter: {
        padding: "0px",
    },
    cardBody: {
        ...theme.typography.title,
        fontWeight: "400",
        color: "#002931",
        marginBottom: "32px",
        height: "48px",
        width: "384px",
        lineHeight: "24px",
        wordBreak: "break-all",

        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        MozBoxOrient: "vertical;",
        MsBoxOrient: "vertical",
        BoxOrient: "vertical",
        WebkitLineClamp: "5",
        MozLineClamp: "5",
        MsLineClamp: "5",
        LineClamp: "5",
        overflow: "hidden",
    },
    blogButton: {
        ...theme.typography.primaryButton,
        padding: "12px 20px",
        width: "119px",
        height: "48px",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        borderRadius: "8px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        position: "absolute",
        left: "0px",
        bottom: "0px",
    },
    partnerContainer: {
        width: "100%",
        height: "339px",
        background: "#F7FBF8",
        paddingLeft: "64px",
        paddingTop: "81px",
        paddingRight: "96px",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "48px",

            paddingRight: "75px",
        },
    },
    partnerTitle: {
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        lineHeight: "32px",
        color: "#002931",
        [theme.breakpoints.down("xs")]: {
            fontSize: "20px",
        },
    },
    partnerInnerContainer: {
        paddingTop: "48px",
        paddingLeft: "16px",
    },
    newsLetterContainer: {
        width: "100%",
        background: "#F2F8F9",
        height: "auto",
        paddingLeft: "101px",
        paddingRight: "96px",
        paddingBottom: "98px",
        backgroundImage: `url(${looper4})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "100% 28%",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "0px",
            paddingRight: "0px",
        },
    },
    newsLetterContent: {
        width: "491px",
        height: "auto",
        paddingTop: "94px",
        [theme.breakpoints.down("sm")]: {
            width: "300px",
            textAlign: "center",
        },
    },

    newLetterSubHeading: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "30px",
    },
    newsLetterForm: {
        // width: "647px",
        height: "337px",
        background: "#FFFFFF",
        boxShadow: "0px 2px 4px rgba(11, 59, 60, 0.05)",
        borderRadius: "10px",
        marginTop: "74px",
        marginLeft: "105px",
        paddingLeft: "42px",
        paddingRight: "42px",
        paddingTop: "54px",
        paddingBottom: "54px",

        [theme.breakpoints.down("md")]: {
            width: "600px",
            paddingLeft: "36px",
            paddingRight: "36px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "530px",
            paddingLeft: "36px",
            paddingRight: "36px",
            marginLeft: "0px",
        },
        [theme.breakpoints.down("xs")]: {
            width: "300px",
            paddingLeft: "24px",
            paddingRight: "24px",
            marginLeft: "0px",
        },
        [theme.breakpoints.up("xl")]: {
            paddingLeft: "0px",
            paddingRight: "0px",
        },
    },
    inputLabel: {
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "20px",
        paddingBottom: "6px",
        fontFamily: "Visuelt Pro",
        marginBottom: "10px",
        /* identical to box height, or 143% */

        /* Gray/700 */

        color: "#344054",
    },
    inputField: {
        background: "#FFFFFF",
        /* Gray/300 */
        width: "100%",
        height: "44px",
        border: "1px solid #D0D5DD",
        boxSizing: "border-box",
        borderRadius: "8px",
        padding: "10px 14px",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "24px",
        "&:focus": {
            border: "1px solid #D0D5DD",
        },
        [theme.breakpoints.down("md")]: {
            width: "100%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    subscribeButton: {
        ...theme.typography.secondaryButton,
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        padding: "10px 0px",
        marginTop: "20px",
        borderRadius: "8px",
        // backgroundColor:"#C53B20",
    },
    Today: {
        height: "36px",
        background: "#e2fff3",
        borderRadius: "0px 0px 5px 5px",
        maxWidth: "420px",
        borderRadius: "0px 0px 5px 5px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "28px"
    }

});

export default LandingStyle;
